export const utList = ["andaman and nicobar islands", "chandigarh", "dadra and nagar haveli and daman and diu", 
                "delhi", "jammu and kashmir", "ladakh", "lakshadweep", "puducherry"];